import {TOGGLE_SIDEBAR} from "../actions/Action_Sidebar";

const defaultState = true;

export default function (state = defaultState, action) {

    switch (action.type){
        case TOGGLE_SIDEBAR:
            return action.payload;
        default:
            return state;
    }
}